module.exports = __webpack_public_path__ + "static/apk_download_badge-44cc5fb547520b9f7d5efb9bac97586b.png";